import Vue from 'vue'
import VueRouter from 'vue-router'
import {authHelper} from "@/utils";
import {getUserInfo} from "@/apis";
import Home from "@/views/Home";
import DocumentFinder from "@/views/DocumentFinder";

Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/',
    //     redirect: 'home',
    // },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
        path: '/:pid/overview',
        name: 'document_finder',
        component: DocumentFinder,
    },
    {
        path: '/:pid/documents',
        name: 'documents',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Documents.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login.vue'),
    },
    // {
    //     path: '/_dev_space_',
    //     name: 'dev_space',
    //     component: () => import('../views/DevSpace.vue')
    // },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const homeLocation = {name: 'home'};

    if (!to.name) {
        next(homeLocation)
        return
    }
    if (authHelper.isAppInitialized()) {
        if (authHelper.isUserAuthenticated()) {
            if (to.name === 'login') {
                next(homeLocation)
            } else {
                next()
            }
        } else {
            if (to.name === 'login') {
                next()
            } else {
                next('login')
            }
        }
    } else {
        authHelper.setInitialUserInfoLoading(true)
        getUserInfo().then((r) => {
            authHelper.setUserAuthenticated(true)
            authHelper.setUserInfo(r)
            authHelper.setAppInitialized(true)
            if (to.name === 'login') {
                next(homeLocation)
            } else {
                next()
            }
        }).catch((r) => {
            if (r.status === 403) {
                authHelper.setAppInitialized(true)
                if (to.name === 'login') {
                    next()
                } else {
                    next({
                        name: 'login',
                        query: {
                            redirectTo: to.fullPath
                        }
                    })
                }
            } else {
                authHelper.setInitError(true)
                next()
            }
        }).always(() => {
            authHelper.setInitialUserInfoLoading(false)
        })
    }
})

export default router
